import type { BoxListItem, CreateBoxInput } from "../../../api/WarehouseApi";
import { BOX_ID_PATTERN } from "../../../domain/entity-ids";
import { resolveBoxReferenceInput } from "../../../utils/boxReference";

function isValidUrl(value: string): boolean {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
}

interface BoxFormInput {
  name: string;
  description: string;
  photo: string;
  typeTags: string[];
  parentInput: string;
  availableBoxes: BoxListItem[];
}

export function resolveParentId(
  parentInput: string,
  availableBoxes: BoxListItem[],
): string {
  return resolveBoxReferenceInput(parentInput, availableBoxes);
}

export function validateBoxForm(input: BoxFormInput): string | null {
  if (!input.name.trim()) {
    return "Укажите название коробки";
  }

  if (input.typeTags.length === 0) {
    return "Добавьте хотя бы один тег типа";
  }

  const parentId = resolveParentId(input.parentInput, input.availableBoxes);
  if (parentId && !BOX_ID_PATTERN.test(parentId)) {
    return "Выберите существующую коробку из списка";
  }

  const photo = input.photo.trim();
  if (photo && !isValidUrl(photo)) {
    return "Ссылка на фото должна быть корректным URL";
  }

  return null;
}

export function buildCreateBoxPayload(input: BoxFormInput): CreateBoxInput {
  const photo = input.photo.trim();
  const parentId = resolveParentId(input.parentInput, input.availableBoxes);

  return {
    name: input.name.trim(),
    description: input.description.trim(),
    photo: photo || undefined,
    typeTags: input.typeTags,
    parentId: parentId || null,
  };
}
